import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function FloatingBookingButton() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [topHovered, setTopHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (location.pathname === '/') {
      const el = document.getElementById('booking');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/#booking');
      setTimeout(() => {
        const el = document.getElementById('booking');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 400);
    }
  };

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div
      className="fixed z-50 flex flex-col items-end gap-3 transition-all duration-500"
      style={{
        bottom: '32px',
        right: '32px',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      {/* Back to Top Button */}
      <button
        onClick={handleBackToTop}
        onMouseEnter={() => setTopHovered(true)}
        onMouseLeave={() => setTopHovered(false)}
        className="relative flex items-center justify-center whitespace-nowrap cursor-pointer rounded-full shadow-xl font-semibold text-sm transition-all duration-300"
        style={{
          width: '46px',
          height: '46px',
          background: topHovered
            ? 'linear-gradient(135deg, #B8860B, #F5D76E)'
            : 'linear-gradient(135deg, #1a1a1a, #2d2d2d)',
          color: topHovered ? '#1a1a1a' : '#F5D76E',
          border: '1.5px solid #B8860B',
          boxShadow: topHovered
            ? '0 6px 24px rgba(184,134,11,0.45)'
            : '0 4px 16px rgba(0,0,0,0.4)',
        }}
        aria-label="Back to Top"
        title="Back to Top"
      >
        <span className="w-5 h-5 flex items-center justify-center" style={{ fontSize: '18px' }}>
          <i className="ri-arrow-up-line"></i>
        </span>
      </button>

      {/* Booking Button */}
      <div className="relative">
        {/* Pulse ring */}
        <span
          className="absolute inset-0 rounded-full animate-ping"
          style={{
            background: 'rgba(184,134,11,0.35)',
            animationDuration: '2s',
          }}
        />

        <button
          onClick={handleClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="relative flex items-center gap-2 whitespace-nowrap cursor-pointer rounded-full shadow-2xl font-semibold text-sm transition-all duration-300"
          style={{
            background: hovered
              ? 'linear-gradient(135deg, #C8102E, #a00d24)'
              : 'linear-gradient(135deg, #B8860B, #F5D76E)',
            color: hovered ? '#ffffff' : '#1a1a1a',
            padding: '14px 22px',
            boxShadow: hovered
              ? '0 8px 32px rgba(200,16,46,0.45)'
              : '0 8px 32px rgba(184,134,11,0.45)',
            letterSpacing: '0.02em',
          }}
          aria-label="Book a Free Consultation"
        >
          <span
            className="w-5 h-5 flex items-center justify-center"
            style={{ fontSize: '16px' }}
          >
            <i className="ri-calendar-check-line"></i>
          </span>
          Book a Free Consultation
        </button>
      </div>
    </div>
  );
}
